var map = {
	"./allWords.json": [
		8058,
		58
	],
	"./base1.json": [
		5270,
		270
	],
	"./base2.json": [
		1111,
		111
	],
	"./base3.json": [
		388,
		388
	],
	"./base4.json": [
		1109,
		109
	],
	"./base5.json": [
		4426,
		426
	],
	"./base6.json": [
		7707,
		707
	],
	"./base7.json": [
		5192,
		192
	],
	"./base8.json": [
		2025,
		25
	],
	"./base9.json": [
		3918,
		918
	],
	"./자동채점.json": [
		8277,
		277
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4399;
module.exports = webpackAsyncContext;